<script>
import AvailableLangs from '@langs/available'

export default {
  computed: {
    langs() {
      // return AvailableLangs.filter(x => x.locale !== this.$i18n.locale)
      return AvailableLangs
    },
    currentLocale() {
      return this.$i18n.locale
    },
  },
  methods: {
    setLocale(locale) {
      this.$i18n.locale = locale
      window.localStorage.setItem('locale', locale)
    },
  },
}
</script>

<template>
  <v-menu
    slot="activator"
    top
    left
    origin="right top"
    transition="scale-transition"
  >
    <v-btn
      slot="activator"
      icon
    >
      <v-icon>language</v-icon>
    </v-btn>
    <v-list dense>
      <v-list-tile
        v-for="lang in langs"
        :key="lang.locale"
        :class="{ active: lang.locale === currentLocale }"
        class="item"
        active-class="active"
        @click="setLocale(lang.locale)"
      >
        <v-list-tile-title>{{ lang.name }}</v-list-tile-title>
      </v-list-tile>
    </v-list>
  </v-menu>
</template>

<style lang="scss" scoped>
@import '@design';
.item {
  cursor: pointer;
}
.active {
  pointer-events: none;
  background-color: #dfdfdf;
}
</style>
